import { ApiResponse, getData } from './Apis';

export type SpeculativePositionModel = {
    ApplyingForID: number,
    CandidateTitle: string,
    ExternalDepartment: string,
    Location: string,
}

export async function API_SpeculativeGetAll(intranetToken? :string): Promise<ApiResponse<SpeculativePositionModel[]>> {
    var url = `webapi/candidate/speculative/GetAvailable${intranetToken?.length ?? 0 > 0 ? "?token="+intranetToken : ""}`
    return await getData<ApiResponse<SpeculativePositionModel[]>>(url);
}
